import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SidebarItemDefinition } from '../../../common/model/sidebar-item';
import { LanguageService } from '../../../core/service/language.service';

class FilteredMenuItem {
  href: string;
  label: string;
  constructor(href: string, label: string) {
    this.href = href;
    this.label = label;
  }
}

@Component({
    selector: 'app-dashboard-new-menu',
    templateUrl: './dashboard-new-menu.component.html',
    styleUrls: ['./dashboard-new-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardNewMenuComponent implements OnInit {
  autoExpandMenu: boolean = true;
  menuActiveState: number = -1;

  filteredMenuItems: any[];
  _menuItems: SidebarItemDefinition[];
  get menuItems() {
    return this._menuItems;
  }
  @Input() set menuItems(value: SidebarItemDefinition[]) {
    this._menuItems = value;
    this.setupTranslatableLabels();
  }
  @Output() menuItemClick = new EventEmitter<void>();
  _menuFilterInput: string = '';

  constructor(private languageService: LanguageService) {}

  stopExpanding() {
    setTimeout(() => {
      this.autoExpandMenu = false;
    }, 10);
  }
  setMenuActiveState(newState: number) {
    this.menuActiveState = newState;
  }

  ngOnInit(): void {
    this.languageService.onLangChange.subscribe(() => {
      console.log('tr:');
      // setTimeout(()=>{
      this.setupTranslatableLabels();
      // }, 1000);
    });
  }

  onSubMenuClick() {
    this.menuItemClick.emit();
  }

  onMenuItemClick() {
    this.menuItemClick.emit();
  }

  setupTranslatableLabels() {
    this.filteredMenuItems = [];
    if (!this._menuItems) return;
    for (let item of this._menuItems) {
      if (item.menuDefinition && item.menuDefinition.length) {
        for (let itemChild of item.menuDefinition) {
          itemChild.label = this.languageService.instant(itemChild.caption);
          this.filteredMenuItems.push(new FilteredMenuItem(itemChild.href, this.languageService.instant(itemChild.caption)));
        }
      }
    }
  }

  filterMenuItems(ev: KeyboardEvent) {}
}
